import axiosPrivate from "./axiosPrivate";

const getPagoProveedores = (periodo, estado = "") => {
  return axiosPrivate.get("pago-proveedores", { params: { periodo, estado } }).then(res => res.data);
};

const guardarPagoProveedor = (data, id = null) => {
  const formData = new FormData();

  Object.entries(data).forEach(([key, value]) => {
    if (value !== undefined && value !== null && value !== "") {
      formData.append(key, key === "incluye_igv" ? (value ? 1 : 0) : value);
    }
  });

  if (id) {
    formData.append("_method", "PUT");
    return axiosPrivate.post(`pago-proveedores/${id}`, formData, {
      headers: { "Content-Type": "multipart/form-data" }
    }).then(res => res.data);
  }

  return axiosPrivate.post("pago-proveedores", formData, {
    headers: { "Content-Type": "multipart/form-data" }
  }).then(res => res.data);
};

const aprobarPagoProveedor = (id, observacion_aprobacion = "") => {
  return axiosPrivate.post(`pago-proveedores/${id}/aprobar`, { observacion_aprobacion }).then(res => res.data);
};

const observarPagoProveedor = (id, observacion_aprobacion) => {
  return axiosPrivate.post(`pago-proveedores/${id}/observar`, { observacion_aprobacion }).then(res => res.data);
};

const marcarPagoRealizado = (id, fecha_pago, archivo_pago) => {
  const formData = new FormData();
  formData.append("fecha_pago", fecha_pago);
  formData.append("archivo_pago", archivo_pago);

  return axiosPrivate.post(`pago-proveedores/${id}/pagar`, formData, {
    headers: { "Content-Type": "multipart/form-data" }
  }).then(res => res.data);
};

const anularPagoProveedor = (id) => {
  return axiosPrivate.delete(`pago-proveedores/${id}`).then(res => res.data);
};

const PagoProveedoresService = {
  getPagoProveedores,
  guardarPagoProveedor,
  aprobarPagoProveedor,
  observarPagoProveedor,
  marcarPagoRealizado,
  anularPagoProveedor,
};

export default PagoProveedoresService;
